import React from 'react'
import scriptLoader from 'react-async-script-loader'
import { Redirect, useLocation } from 'react-router-dom'

import { MAPS_SCRIPT_URL } from '../components/location-search/LocationSearchBox'
import { rootRoute } from '../routes/routes'

export const PageRegister = () => {
  const { search } = useLocation()

  // Keep the query string (referral token/ref_code, teamInviteCode, etc.) so the
  // flow this redirects into still has it.
  return <Redirect to={`${rootRoute.path}${search}`} />
}

export default scriptLoader(MAPS_SCRIPT_URL)(PageRegister)
